import { render, staticRenderFns } from "./SyncMessageDialog.vue?vue&type=template&id=1f59f4aa&"
import script from "./SyncMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SyncMessageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports